import { calculateUploadState, isHttpProgressEvent, isHttpResponse, isInstanceOfUploadedFile } from "./file-upload-utils";

export const FileUploadUtils = {
    isInstanceOfUploadedFile,
    isHttpResponse,
    isHttpProgressEvent,
    calculateUploadState,
};
